import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    contentTitleContainer: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
    },
    mainWrapper: {
        display: "flex",
        flexDirection: "column",
        textAlign: "left",
        fontFamily: "Source Sans 3",
        backgroundColor: theme.palette.backgrounds.main,
        minHeight: "calc(100vh - 64px)",
    },
    tabs: {
        padding: "0px 22px",
        "&.MuiTabs-root .MuiTabs-scroller .MuiTabs-indicator": {
            borderBottom: "none",
            backgroundColor: "transparent",
        },
        "&.MuiTabs-root .MuiTabs-scroller .MuiTabs-flexContainer .MuiButtonBase-root": {
            fontFamily: "Source Sans 3",
            fontWeight: 400,
            fontSize: "14px",
            color: theme.palette.corporateBO.tabText,
            textTransform: "none",
            padding: 0,
            minWidth: 0,
        },
        "&.MuiTabs-root .MuiTabs-scroller .MuiTabs-flexContainer .Mui-selected": {
            fontFamily: "Source Sans 3",
            fontWeight: 600,
            fontSize: "14px",
            color: theme.palette.corporateBO.tabText,
            textTransform: "none",
            borderBottom: `3px solid ${theme.palette.border.tabs}`,
        },
        "&.MuiTabs-root .MuiTabs-scroller .MuiTabs-flexContainer": {
            gap: theme.spacing(6),
        },
    },
}));
